import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { MisReportsView } from "../../components/MisReportsView";
import { TerritoryGateSkeleton } from "../../components/TerritoryGate";
import { useMeState, useRoleModules } from "../../lib/roleModules";
import { useAuth } from "../../context/AuthContext";

const SUP_IDS = {
  stickyWrap: "sup-reports-area-filter-sticky", filterCard: "sup-reports-area-filter-card", areaPrefix: "sup-reports-area",
  grid: "sup-reports-grid", fieldSection: "sup-mis-field-activity-section", fieldPrefix: "sup-mis-field-activity",
  syncSection: "sup-mis-sync-health-section", syncPrefix: "sup-mis-sync-health",
};

/** Phase 143 — Supervisor MIS Reports: the Admin page's sections, every figure limited to the supervisor's
 *  mapped zone(s). "View only" shows everything on screen without downloads; "Full access" adds PDF / Excel. */
export default function SupervisorMisReports() {
  const { code } = useParams();
  const { auth } = useAuth();
  const access = useRoleModules(code);
  const { loaded } = access;
  const { me, loading } = useMeState(code);
  const isSupervisor = auth?.user?.role === "supervisor";
  const status = me?.territory_status;
  const lockedZoneIds = useMemo(() => (isSupervisor ? (status?.zone_ids || []) : null), [isSupervisor, status]);

  if ((loading && isSupervisor) || !loaded) return <TerritoryGateSkeleton />;
  // Phase 152: "reports.mis_reports" / "reports.field_activity" sub-features (module-level "View only" still means no downloads)
  const canDownload = isSupervisor ? access.featureLevel("reports", "mis_reports") === "write" : true;
  const showCards = isSupervisor ? access.featureAllowed("reports", "mis_reports") : true;
  const showField = isSupervisor ? access.featureAllowed("reports", "field_activity") : true;
  const canExportField = isSupervisor ? access.featureLevel("reports", "field_activity") === "write" : true;
  return (
    <MisReportsView code={code} ids={SUP_IDS} expandable
      title="MIS Reports"
      subtitle={isSupervisor ? `Management reports for your mapped zone${(status?.zones || []).length > 1 ? "s" : ""}${status?.zones?.length ? ` — ${status.zones.join(", ")}` : ""}` : "Download management reports as PDF or Excel"}
      canDownload={canDownload}
      hideReportCards={!showCards}
      showFieldActivity={showField}
      canExportFieldActivity={canExportField}
      lockedZoneIds={lockedZoneIds}
      scopeZoneNames={isSupervisor ? (status?.zones || []) : []} />
  );
}
